import React, { useState, useEffect, memo } from 'react';
import json from '../../Auditoria/locale.json';
import { Objeto } from '../../../../Services/Models';
import { L10n } from '@syncfusion/ej2-base';
import { Icon } from '@blueprintjs/core';
import { PivotViewComponent, IDataOptions, Inject, CalculatedField, FieldList, Toolbar, PDFExport, ExcelExport } from '@syncfusion/ej2-react-pivotview';
import { ButtonComponent } from "@syncfusion/ej2-react-buttons";
import { CPF, CEP, Moeda, Numero, Telefone, CNPJ, Data } from '../../../../Themes/TextFormat';
import './style.css'
import { PdfHeaderQueryCellInfoEventArgs, PdfQueryCellInfoEventArgs } from '@syncfusion/ej2-react-grids'
import { NotificacaoInterna } from '../../../../Services/Notification';
import { useHistory } from "react-router-dom";
import apiAdonis from '../../../../Services/adonis';
L10n.load(json)

function App({ realizar }: any) {
  const History = useHistory();
  async function VerifyToken() {

    await apiAdonis.post('/verify', {}, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`
      }
    }).then(async result => {
      if (result.data.check) {
        return null
      }
      else {
        NotificacaoInterna.ExibirNotificacao("Acesso Expirado!", "Seu acesso à aplicação foi expirado!", NotificacaoInterna.TipoDeNotificacao.Informacao);
        History.replace("/");
        window.location.reload();
      }
    });
  }

  const [getData, setData] = useState(realizar);
  const [getSaldoAtual, setSaldoAtual] = useState<number>(0);
  let pivotObj: PivotViewComponent;

  //CPF
  let dataSourceSettingsVencidas: IDataOptions = {
    enableSorting: true,
    columns: [{ name: 'Divisao' }, { name: 'Divisao' }],
    valueSortSettings: { headerDelimiter: ' - ' },
    values: [{ name: 'APAGAR', caption: 'A Pagar' } /*, { name: 'Amount', caption: 'Sold Amount' }*/],
    dataSource: getData ? getData.vencidos.data : {},
    rows: [{ name: 'CATMOV', caption: 'Movimentação Financeira' }, { name: "FORNECEDOR" }, { name: 'PROC', caption: 'PROC' }],
    formatSettings: [{ name: 'APAGAR', format: 'C2' }],
    expandAll: false
  };
  let dataSourceSettingsVencer: IDataOptions = {
    enableSorting: true,
    columns: [{ name: 'Divisao' }, { name: 'Divisao' }],
    valueSortSettings: { headerDelimiter: ' - ' },
    values: [{ name: 'APAGAR', caption: 'A Pagar' } /*, { name: 'Amount', caption: 'Sold Amount' }*/],
    dataSource: getData ? getData.vencerDia.data : {},
    rows: [{ name: 'CATMOV', caption: 'Movimentação Financeira' }, { name: "FORNECEDOR" }, { name: 'PROC', caption: 'PROC' }],
    formatSettings: [{ name: 'APAGAR', format: 'C2' }],
    expandAll: false
  };
  let dataSourceSettingsVencerFuturo: IDataOptions = {
    enableSorting: true,
    columns: [{ name: 'Divisao' }, { name: 'Divisao' }],
    valueSortSettings: { headerDelimiter: ' - ' },
    values: [{ name: 'APAGAR', caption: 'A Pagar' } /*, { name: 'Amount', caption: 'Sold Amount' }*/],
    dataSource: getData ? getData.vencerFuturo.data : {},
    rows: [{ name: 'CATMOV', caption: 'Movimentação Financeira' }, { name: "FORNECEDOR" }, { name: 'PROC', caption: 'PROC' }],
    formatSettings: [{ name: 'APAGAR', format: 'C2' }],
    expandAll: false
  };

  useEffect(() => {
    async function componentDidMount() {
      await VerifyToken();
      if (realizar !== undefined) {
        await setData(JSON.parse(JSON.stringify(realizar).replace(/KEY_CDEMP_CDOBR_BD/g, 'Nome obra')))
      }
    }
    componentDidMount();
  }, [realizar])
  const pdfQueryCellInfo = (args: PdfQueryCellInfoEventArgs | any) => {
    args.cell.cellHeight = 10;
  }
  const pdfHeaderQueryCellInfo = (args: PdfHeaderQueryCellInfoEventArgs | any) => {
    (args.cell as any).row.pdfGrid.repeatHeader = true;
    args.cell.gridRow.pdfGrid.columns.getColumn(0).width = 200;
    args.cell.gridRow.pdfGrid.columns.getColumn(2).textAlign = "Right";
  }
  function btnClick() {
    pivotObj.pdfExport({
      pageOrientation: "Landscape",
      exportType: 'AllPages',
      theme: {
        header: { fontSize: 5, bold: true },
        record: { fontSize: 5, }
      },
      header: {
        fromTop: 0,
        height: 20,
        contents: [
          {
            type: 'Text',
            value: "Relatório",
            position: { x: 0, y: 0 },
            style: { textBrushColor: '#000000', fontSize: 13, dashStyle: 'Solid', hAlign: 'Center' }
          }
        ]
      },
      footer: {
        fromBottom: 0,
        height: 40,
        contents: [
          {
            type: 'PageNumber',
            pageNumberType: 'Arabic',
            format: 'Page {$current} of {$total}',
            position: { x: 0, y: 0 },
            style: { textBrushColor: '#000000', fontSize: 15 }
          }
        ]
      },
      allowHorizontalOverflow: false
    });
  }
  return (
    <>
      <div style={{ width: "60%", margin: "40px auto", borderRadius: "5px", padding: "20px", background: "#ffffff" }}>
        {/* Resumo */}
        <div style={{ width: "100%", display: "flex", flexWrap: "wrap", alignItems:"center", justifyContent:"space-between" }}>
          <div style={{ backgroundColor: "#f3f3f3", color: Math.sign(getSaldoAtual) === -1 ? "#FF5666" : "#557dff", width: "25%", minWidth: "175px", height: "100px", borderRadius: "5px", padding: "0 20px", display: "flex", alignItems: "center", justifyContent: "space-between" }}>
            <Icon color={Math.sign(getSaldoAtual) === -1 ? "#FF5666" : "#557dff"} icon="doughnut-chart" iconSize={30} />
            <div style={{ display: "flex", flexDirection: "column" }}>
              <span>Saldo Atual C/C</span>
              <span style={{ fontSize: "28px" }}>{Math.round(getSaldoAtual).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")}</span>
            </div>
          </div>
          <div style={{ backgroundColor: "#FF5666", color: "#ffffff", width: "40%", minWidth: "280px", height: "100px", borderRadius: "5px", padding: "0 20px", display: "flex", alignItems: "center", justifyContent: "space-between" }}>
            <Icon icon="swap-horizontal" iconSize={30} />
            <div style={{ display: "flex", background: "0", flexDirection: "row", flexWrap: "wrap", alignItems: "center", justifyContent: "space-between  ", width: "80%", height: "100%" }}>
              <div style={{ display: "flex", background: "0", flexDirection: "column", width: "28%", minWidth: "90px" }}>
                <span style={{ fontSize: "12px" }}>Pagar em atraso</span>
                <span style={{ fontSize: "18px" }}>{getData ? Math.round(getData.vencidos.totalVencidos).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".") : "00"}</span>
              </div>
              <div style={{ display: "flex", background: "0", flexDirection: "column", width: "28%", minWidth: "90px" }}>
                <span style={{ fontSize: "12px" }}>Pagar Hoje</span>
                <span style={{ fontSize: "18px" }}>{getData ? Math.round(getData.vencerDia.totalVencerDia).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".") : "00"}</span>
              </div>
              <div style={{ display: "flex", background: "0", flexDirection: "column", width: "28%", minWidth: "90px" }}>
                <span style={{ fontSize: "12px" }}>Pagar Futuro</span>
                <span style={{ fontSize: "18px" }}>{getData ? Math.round(getData.vencerFuturo.totalVencerFuturo).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".") : "00"}</span>
              </div>
            </div>
          </div>
          <div style={{ backgroundColor: "#FF5666", color: "#ffffff", width: "25%", minWidth: "175px", height: "100px", borderRadius: "5px", padding: "0 20px", display: "flex", alignItems: "center", justifyContent: "space-between" }}>
            <Icon icon="dollar" iconSize={30} />
            <div style={{ display: "flex", background: "0", padding: "10px 0", flexDirection: "column", alignItems: "center", justifyContent: "center", width: "80%", height: "100%" }}>
              <div style={{ display: "flex", flexDirection: "column", width: "100%" }}>
                <span style={{ fontSize: "12px" }}>Total Pessoa Física</span>
                <span style={{ fontSize: "18px" }}>{getData ? Math.round(getData.vencidos.totalVencidosPF).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".") : "00"}</span>
              </div>
              <div style={{ display: "flex", flexDirection: "column", width: "100%" }}>
                <span style={{ fontSize: "12px" }}>Total Pessoa Jurídica</span>
                <span style={{ fontSize: "18px" }}>{getData ? Math.round(getData.vencidos.totalVencidosPJ).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".") : "00"}</span>
              </div>
            </div>
          </div>
        </div>
        {/* Tables */}
        <div style={{ fontSize: "25px", margin: "30px 0 15px 0" }}>Contas a Pagar</div>
        <div style={{ backgroundColor: "#f3f3f3", padding: "10px", borderRadius: "5px", marginBottom: "20px" }}>
          <div style={{ color: "black", fontSize: "18px", marginBottom: "10px" }}>Contas vencidas</div>
          <div style={{ width: '100%', margin: "0px auto" }}>
            <div style={{ overflow: 'auto', width: "100%" }}>
              <PivotViewComponent
                ref={(d) => (d != null ? pivotObj = d : null)}
                id='PivotViewVencidas'
                dataSourceSettings={dataSourceSettingsVencidas}
                showToolbar={true}
                gridSettings={{ columnWidth: 140, allowTextWrap: false }}
                allowExcelExport={true}
                allowPdfExport={true}
                toolbar={["FieldList"]}
                pdfHeaderQueryCellInfo={pdfHeaderQueryCellInfo}
                pdfQueryCellInfo={pdfQueryCellInfo}
                height={500}
                width="100%"
                locale='pt-BR'
                style={{ overflow: "auto" }}
                allowCalculatedField={true}
                showFieldList={true}
              >
                <Inject services={[FieldList, CalculatedField, Toolbar]} />
              </PivotViewComponent>
            </div>
          </div>
        </div>
        <div style={{ backgroundColor: "#f3f3f3", padding: "10px", borderRadius: "5px", marginBottom: "20px" }}>
          <div style={{ color: "black", fontSize: "18px", marginBottom: "10px" }}>Contas a vencer no dia</div>
          <div style={{ width: '100%', margin: "0px auto" }}>
            <div style={{ overflow: 'auto', width: "100%" }}>
              <PivotViewComponent
                ref={(d) => (d != null ? pivotObj = d : null)}
                id='PivotViewVencer'
                dataSourceSettings={dataSourceSettingsVencer}
                showToolbar={true}
                gridSettings={{ columnWidth: 140, allowTextWrap: false }}
                allowExcelExport={true}
                allowPdfExport={true}
                toolbar={["FieldList"]}
                pdfHeaderQueryCellInfo={pdfHeaderQueryCellInfo}
                pdfQueryCellInfo={pdfQueryCellInfo}
                height={500}
                width="100%"
                locale='pt-BR'
                style={{ overflow: "auto" }}
                allowCalculatedField={true}
                showFieldList={true}
              >
                <Inject services={[FieldList, CalculatedField, Toolbar]} />
              </PivotViewComponent>
            </div>
          </div>
        </div>
        <div style={{ backgroundColor: "#f3f3f3", padding: "10px", borderRadius: "5px", marginBottom: "20px" }}>
          <div style={{ color: "black", fontSize: "18px", marginBottom: "10px" }}>Contas a vencer Futuro</div>
          <div style={{ width: '100%', margin: "0px auto" }}>
            <div style={{ overflow: 'auto', width: "100%" }}>
              <PivotViewComponent
                ref={(d) => (d != null ? pivotObj = d : null)}
                id='PivotViewVencerFuturo'
                dataSourceSettings={dataSourceSettingsVencerFuturo}
                showToolbar={true}
                gridSettings={{ columnWidth: 140, allowTextWrap: false }}
                allowExcelExport={true}
                allowPdfExport={true}
                toolbar={["FieldList"]}
                pdfHeaderQueryCellInfo={pdfHeaderQueryCellInfo}
                pdfQueryCellInfo={pdfQueryCellInfo}
                height={500}
                width="100%"
                locale='pt-BR'
                style={{ overflow: "auto" }}
                allowCalculatedField={true}
                showFieldList={true}
              >
                <Inject services={[FieldList, CalculatedField, Toolbar]} />
              </PivotViewComponent>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default memo(App);